import app_config from '@/commons/app_config';
import axios from 'axios';
import Vue from 'vue';
import _ from 'lodash';
import { AuthManage } from '@/plugins/auth';
import store from '../vuex';
import getQueryVariable from '@/assets/js/getQuery';
import router from '../../router';
import {
  localeKeyToValueMap,
  localeValueToKeyMap
} from '@/assets/js/multilingual-tools';

let cancellation = false;
// 取消請求
const CancelToken = axios.CancelToken;
let cancel,
  promiseArr = {};

const getLanguage = () => {
  const defaultI18n = process.env.VUE_APP_REGION === 'yoov' ? 'zh-HK' : 'zh-CN';
  const i18n = localStorage.getItem('i18n');
  const navigatorLanguage = localeValueToKeyMap[navigator.language];
  const browserLocale = localeKeyToValueMap[i18n]
    ? localeKeyToValueMap[i18n]
    : navigatorLanguage
    ? navigatorLanguage
    : 'zh-HK';
  return _.isNil(i18n) ? defaultI18n : browserLocale;
};

let Axios = axios.create({
  baseURL: `${app_config.mainApiEndpoint}/`,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Accept-Language': getLanguage()
  }
});

// 配置API接口地址 将API方法绑定到全局
// http request 拦截器
//axios的一些配置，比如发送请求显示loading，请求回来loading消失之类的
Axios.interceptors.request.use(
  async (config) => {
    //發起請求時，取消掉當前正在進行的相同請求
    if (promiseArr[config.url]) {
      promiseArr[config.url] = cancel;
    }
    //配置发送请求的信息
    if (AuthManage && AuthManage.token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = `bearer ${AuthManage.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

// http response 攔截器
Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error && error.response) {
      switch (error.response.status) {
        case 401:
          if (AuthManage && AuthManage.logoutFn) {
            AuthManage.logoutFn();
          } else {
            location.href = location.origin;
          }
          break;
        case 403:
          // Vue.$Message.error('拒絕訪問')
          // Vue.$router.push('/401')
          break;
        case 404:
          Vue.prototype.$Message.error('請求錯誤,未找到該資源');
          break;
        case 405:
          Vue.prototype.$Message.error('請求方法未允許');
          break;
        case 408:
          Vue.prototype.$Message.error('請求超時');
          break;
        case 500:
          Vue.prototype.$router.push('/500');
          Vue.prototype.$Message.error('服務器端出錯');
          break;
        case 501:
          Vue.prototype.$Message.error('網絡未實現');
          break;
        case 502:
          Vue.prototype.$Message.error('網絡錯誤');
          break;
        case 503:
          Vue.prototype.$Message.error('服務不可用');
          break;
        case 504:
          Vue.prototype.$Message.error('網絡超時');
          break;
        case 505:
          Vue.prototype.$Message.error('http版本不支持該請求');
          break;
      }
    } else if (!cancellation) {
      Vue.prototype.$Message.error('連接到服務器失敗');
    }
    return Promise.reject(error.response);
  }
);

export default (method, url, data, isAuthTeam, gateway, responseType, type) => {
  let is_http = _.isArray(url.split(':')) ? url.split(':')[0] : null;
  method = method.toLowerCase();
  return new Promise((resolve, reject) => {
    let params = {
      method,
      url: is_http === 'https' ? url : `${gateway || 'rest'}/api/v1/${url}`,
      data: method === 'post' || method === 'put' ? data : null,
      params: method === 'get' || method === 'delete' ? data : null,
      responseType: responseType,
      cancelToken: new CancelToken((c) => {
        cancel = c;
      })
    };
    if (isAuthTeam) {
      const header = {
        'Accept-Language': getLanguage()
      };
      const teamId = localStorage.getItem('teamId');
      if (teamId) {
        header['X-TENANT-ID'] = teamId;
      }
      if (type) {
        header['Content-Type'] = 'application/zip';
      }
      params.headers = header;
    }
    const switchLanguage = window.localStorage.getItem('switchLanguage');

    if (
      switchLanguage &&
      params.headers &&
      !params.headers['Accept-Language']
    ) {
      params.headers['Accept-Language'] = getLanguage();
      window.localStorage.removeItem('switchLanguage');
    }

    if (switchLanguage && !params.headers) {
      params.headers = {
        'Accept-Language': getLanguage()
      };
      window.localStorage.removeItem('switchLanguage');
    }
    Axios(params)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        if (responseType === 'arraybuffer') {
          const array = new Uint8Array(error.data);
          const json = [];
          for (let i = 0; i < array.length; ++i) {
            json.push(array[i]);
          }
          const copy = new Buffer(
            JSON.parse(JSON.stringify({ type: 'Buffer', data: json }))
          );
          if (JSON.parse(copy.toString()).fieldErrors) {
            JSON.parse(copy.toString()).fieldErrors.length > 0 &&
              Vue.prototype.$Message.error({
                content: JSON.parse(copy.toString()).fieldErrors[0].message,
                duration: 8
              });
          } else {
            Vue.prototype.$Message.error({
              content: JSON.parse(copy.toString()).message,
              duration: 8
            });
          }
        } else if (responseType === 'blob') {
          let fileReader = new FileReader(error.data);
          fileReader.onload = function (e) {
            try {
              if (JSON.parse(e.target.result)) {
                Vue.prototype.$Message.error({
                  content: JSON.parse(e.target.result).message,
                  duration: 8
                });
              }
            } catch (err) {}
          };
          fileReader.readAsText(error.data);
        } else {
          if (error && error.data.code === 402) {
            cancellation = true;
            cancel();
            // 团队被注销
            const teamId = localStorage.getItem('teamId');
            if (teamId) {
              Axios.get(`/rest/api/v1/mobile/t/teams/${teamId}`).then(
                (res1) => {
                  Axios.get(`/rest/api/v1/mobile/t/teams?page=0&size=1`).then(
                    (res2) => {
                      store.commit('set_team', res1.data);
                      let title = '';
                      let content = '';
                      let okText = '';
                      let i1n8Key = window.localStorage.getItem('i18n') || 'cn';
                      if (i1n8Key) {
                        const t = window.VM.$i18n.messages[i1n8Key];
                        title = t.team.tip;
                        content = `${res1.data.name}${t.team.cancellationTip}`;
                        okText = t.team.iSee;
                      }
                      Vue.prototype.$Modal.error({
                        title: title,
                        content: content,
                        okText: okText,
                        onOk: () => {
                          cancellation = false;
                          if (res2.data.content.length === 0) {
                            // 没有团队时，退出登录
                            AuthManage.logoutFn();
                          } else {
                            // 打开选择团队弹窗
                            store.commit('selectTeamChange', true);
                          }
                        }
                      });
                    }
                  );
                }
              );
            } else {
              AuthManage.logoutFn();
            }
            return;
          }
          if (error && error.status !== 401 && error.data.code !== 1001) {
            const from = getQueryVariable('from');
            // 邮件打开的地址，不执行message报错提示
            if (from === 'transit') return;
            if (!_.isNil(error)) {
              if (error.data.fieldErrors && error.data.fieldErrors.length > 0) {
                Vue.prototype.$Message.error({
                  content: error.data.fieldErrors[0].message,
                  duration: 8
                });
              } else {
                Vue.prototype.$Message.error({
                  content: error.data.message
                    ? error.data.message
                    : error.message,
                  duration: 8
                });
              }
            }
          }
          if (error && error.data && error.data.code === 1001) {
            // 跳转“找不到页面”页面
            router.replace('/approverError?type=notFound');
          }
        }
      });
  });
};
